import React, { useEffect, useState } from "react";
import { Button, Row, Col, Card } from "react-bootstrap";
import { fetchJson } from "../utils/fetchJson";
const ManagementTeam = () => {
  const [team, setTeam] = useState([]);
  const [menu, setMenu] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // 加载团队成员数据
  useEffect(() => {
    fetchJson("/json/team.json")
      .then((response) => response.json())
      .then((data) => setTeam(data.data))
      .catch((error) => console.error("加载成员数据失败:", error));
    getMenu();
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const getMenu = () => {
    fetchJson("/json/aboutMenu.json")
      .then((response) => response.json())
      .then((data) => setMenu(data))
      .catch((error) => console.error("menu:", error));
  };
  return (
    <div>
      <div className="page-title">
        <h1>Academic Management Consultant</h1>
      </div>
      <Row>
        <Col xs={12} md={3}>
          <Card
            style={{
              maxHeight: isMobile
                ? "calc(100vh - 40px)"
                : "calc(100vh - 100px)",
              overflowY: "auto",
              padding: isMobile ? "1rem" : "1.5rem",
              position: isMobile ? "static" : "sticky",
              top: isMobile ? "auto" : "100px",
              left: isMobile ? "auto" : 0,
              zIndex: 10,
            }}
          >
            <Card.Header
              style={{
                padding: 0,
                borderBottom: "2px solid #3498db",
                marginBottom: "1rem",
                backgroundColor: "transparent",
              }}
            >
              <h3
                style={{
                  color: "#2c3e50",
                  paddingBottom: "10px",
                  margin: 0,
                  fontSize: isMobile ? "1.2rem" : "1.3rem",
                }}
              >
                Overview
              </h3>
            </Card.Header>
            <Card.Body style={{ padding: 0 }}>
              <ul className="p-0">
                {menu.map(({ id, title, link }) => (
                  <li key={id}>
                    <a
                      href={link}
                      className={`btn d-flex justify-content-between align-items-center btn-secondary`}
                      style={{
                        display: "block",
                        textAlign: "left",
                        padding: "8px 15px",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          flexGrow: 1,
                          marginRight: "8px",
                        }}
                      >
                        {title}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={9}>
          <main style={{ flex: 1 }}>
            {team.map((member, index) => (
              <div
                key={member.id || index}
                className="card"
                style={{
                  overflow: "auto",
                  display: "block",
                  height: "auto",
                  marginBottom: "20px",
                }}
              >
                {/* 头像：左浮动 + 间距 */}
                <img
                  src={member.url}
                  alt={member.title}
                  style={{
                    width: "80px",
                    objectFit: "cover",
                    borderRadius: "4px",
                    float: "left",
                    marginRight: "15px",
                  }}
                />

                {/* 文字内容：自然环绕 */}
                <div>
                  <h3
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: 600,
                      marginBottom: "8px",
                      display:"flex",
                      alignItems:"center"
                    }}
                  >
                    {member.title}
                        {member.orcidUrl && (
                          <a target="_blank" href={member.orcidUrl}
                          style={{display:"flex",
                          alignItems:"center",
                          }}>
                            <svg
                              width="1.2rem"
                              height="1.2rem"
                              viewBox="0 0 72 72"
                              version="1.1"
                              href={member.orcidUrl}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <g
                                  id="hero"
                                  transform="translate(-924.000000, -72.000000)"
                                  fillRule="nonzero"
                                >
                                  <g id="Group-4">
                                    <g
                                      id="vector_iD_icon"
                                      transform="translate(924.000000, 72.000000)"
                                    >
                                      <path
                                        d="M72,36 C72,55.884375 55.884375,72 36,72 C16.115625,72 0,55.884375 0,36 C0,16.115625 16.115625,0 36,0 C55.884375,0 72,16.115625 72,36 Z"
                                        id="Path"
                                        fill="#A6CE39"
                                      ></path>
                                      <g
                                        id="Group"
                                        transform="translate(18.868966, 12.910345)"
                                        fill="#FFFFFF"
                                      >
                                        <polygon
                                          id="Path"
                                          points="5.03734929 39.1250878 0.695429861 39.1250878 0.695429861 9.14431787 5.03734929 9.14431787 5.03734929 22.6930505 5.03734929 39.1250878"
                                        ></polygon>
                                        <path
                                          d="M11.409257,9.14431787 L23.1380784,9.14431787 C34.303014,9.14431787 39.2088191,17.0664074 39.2088191,24.1486995 C39.2088191,31.846843 33.1470485,39.1530811 23.1944669,39.1530811 L11.409257,39.1530811 L11.409257,9.14431787 Z M15.7511765,35.2620194 L22.6587756,35.2620194 C32.49858,35.2620194 34.7541226,27.8438084 34.7541226,24.1486995 C34.7541226,18.1301509 30.8915059,13.0353795 22.4332213,13.0353795 L15.7511765,13.0353795 L15.7511765,35.2620194 Z"
                                          id="Shape"
                                        ></path>
                                        <path
                                          d="M5.71401206,2.90182329 C5.71401206,4.441452 4.44526937,5.72914146 2.86638958,5.72914146 C1.28750978,5.72914146 0.0187670918,4.441452 0.0187670918,2.90182329 C0.0187670918,1.33420133 1.28750978,0.0745051096 2.86638958,0.0745051096 C4.44526937,0.0745051096 5.71401206,1.36219458 5.71401206,2.90182329 Z"
                                          id="Path"
                                        ></path>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </a>
                        )}
                        {member.scopusUrl && (
                          <a target="_blank" href={member.scopusUrl}>
                            <img
                              src="/images/icon/scopus.png"
                              style={{ height: "1.2rem",marginLeft:"10px", cursor: "pointer" }}
                            />
                          </a>
                        )}
                  </h3>
                  {member.email && (
                    <p className="m-0 p-0" style={{ color: "gray" }}>
                      Email: {member.email}
                    </p>
                  )}
                  <p
                    className="m-0"
                    style={{
                      lineHeight: "1.6",
                      textAlign: isMobile ? "" : "justify",
                    }}
                  >
                    {member.desc}
                  </p>
                </div>
              </div>
            ))}
          </main>
        </Col>
      </Row>
    </div>
  );
};

export default ManagementTeam;
